import {
  useCurrentModule,
  useRecommendationRevealEnabled,
} from '@wix/package-picker-shared-eclipse';

export const CURRENT_PLAN_TAB_HEIGHT = 42;

export interface CurrentPlanTab {
  rowHasTab: boolean;
  showsTab: boolean;
}

export const useCurrentPlanTab = (productId?: string): CurrentPlanTab => {
  const module = useCurrentModule();
  const { isUpgradeReveal } = useRecommendationRevealEnabled();
  const { data: offering } =
    module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const currentProductId = offering?.currentSubscriptionInfo?.productId ?? '';
  const isCurrentProductInOffering = Boolean(
    currentProductId &&
      offering?.products?.some(
        (product) => product.productId === currentProductId,
      ),
  );
  const { data: currentProduct } =
    module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      { productId: currentProductId },
      isUpgradeReveal && isCurrentProductInOffering,
    );

  const rowHasTab =
    isUpgradeReveal &&
    isCurrentProductInOffering &&
    Boolean(currentProduct?.hasSale);

  return {
    rowHasTab,
    showsTab: rowHasTab && productId === currentProductId,
  };
};
